import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode | React.ReactNode[],
}

function Button({
  children,
  type,
  id,
  className,
  disabled,
  ...rest
}: ButtonProps) {
  return (
    <button
      className={className}
      id={id}
      type={type} // eslint-disable-line react/button-has-type -- The type system should protect us enough to allow this
      disabled={disabled}
      {...rest}
    >
      {children}
    </button>
  );
}

export default Button;
